import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import PageWrapper from "./PageWrapper";
import logoAfrique from "../assets/logo-afrique.png";

const IntroLogo = ({ onFinish }) => {
  return (
    <PageWrapper>
      <AnimatePresence>
        <motion.div
          className="intro-logo-container"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#000",
            zIndex: 9999,
            position: "fixed",
            top: 0,
            left: 0,
          }}
        >
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1.2, opacity: 1 }}
            transition={{ duration: 2, ease: "easeInOut" }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: "70%",
              maxHeight: "70%",
            }}
          >
            <img
              src={logoAfrique}
              alt="Logo Afrique"
              style={{
                objectFit: "contain",
                width: "100%",
                height: "100%",
              }}
            />
          </motion.div>

          <motion.div
            className="text-center space-y-4 mt-12" // Réduction de l'espacement
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5, duration: 0.8 }}
            style={{ color: "white", maxWidth: "90%" }} // Contrôle de la largeur
          >
            <h1 className="text-2xl md:text-3xl font-bold"> {/* Taille réduite */}
            Bienvenue sur notre plateforme de diagnostic médical en ligne.
            </h1>

            <motion.button
              onClick={onFinish}
              className="mt-6 bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-full text-base" // Taille réduite
              whileHover={{ scale: 1.05 }}
              
            >
              Commencer
            </motion.button>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </PageWrapper>
  );
};

export default IntroLogo;